import React from "react";
import {
  Layout,
  Row,
  Col,
  Input,
  Button,
  Typography,
  Space,
  List,
  Divider,
} from "antd";
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  PhoneOutlined,
  MailOutlined,
  AppleOutlined,
  AndroidOutlined,
  WindowsOutlined,
} from "@ant-design/icons";
import { theme } from "../../utils/theme";

const { Footer } = Layout;
const { Title, Text, Link } = Typography;
const personelIcon = `${process.env.PUBLIC_URL}/hemen_personel_icon.png`;

export default function FooterHome() {
  // Custom style for links
  const linkStyle = {
    color: "#333333", // Same color as the footer text
    "&:hover": {
      color: "#666", // Darker shade on hover
    },
  };

  return (
    <Footer
      style={{
        background: "#f5f5f5",
        color: "#a0a0a0",
      }}>
      <Row gutter={[32, 32]} style={{ marginTop: "20px" }}>
        <Col xs={24} md={6}>
          <img
            src={personelIcon}
            alt="Logo"
            style={{ marginBottom: "16px", width: 50 }}
          />
          <Text style={{ display: "block", marginBottom: "16px" }}>
            Hemen Personel veya Personelika ile ilgili bilgilerin yer alacağı
            kısım
          </Text>
          <Space size="large">
            <Link
              href="https://www.google.com"
              target="_blank"
              style={linkStyle}>
              <FacebookOutlined style={{ fontSize: "24px" }} />
            </Link>
            <Link
              href="https://www.google.com"
              target="_blank"
              style={linkStyle}>
              <TwitterOutlined style={{ fontSize: "24px" }} />
            </Link>
            <Link
              href="https://www.google.com"
              target="_blank"
              style={linkStyle}>
              <InstagramOutlined style={{ fontSize: "24px" }} />
            </Link>
          </Space>
        </Col>
        <Col xs={24} md={6}>
          <Title level={4}>Useful Link</Title>
          <List
            dataSource={[
              "Hakkımızda",
              "Servislerimiz",
              "İşleri Keşfet",
              "Candidates",
              "İletişime Geç",
            ]}
            renderItem={(item) => (
              <List.Item>
                <Link
                  href="https://www.google.com"
                  target="_blank"
                  style={linkStyle}>
                  {item}
                </Link>
              </List.Item>
            )}
          />
        </Col>
        <Col xs={24} md={6}>
          <Title level={4}>İndir</Title>
          <List
            dataSource={[
              { text: "App Store", icon: <AppleOutlined /> },
              { text: "Google Play", icon: <AndroidOutlined /> },
            ]}
            renderItem={(item) => (
              <List.Item>
                <Link
                  href="https://www.google.com"
                  target="_blank"
                  style={linkStyle}>
                  <Space>
                    {item.icon}
                    {item.text}
                  </Space>
                </Link>
              </List.Item>
            )}
          />
        </Col>
        <Col xs={24} md={6}>
          <Title level={4}>Contact</Title>
          <Space
            direction="vertical"
            size="small"
            style={{ marginBottom: "16px" }}>
            <Space>
              <PhoneOutlined />
              <Text>(+90) 541-913-9623</Text>
            </Space>
            <Space>
              <MailOutlined />
              <Text>mahmut@mail.com</Text>
            </Space>
          </Space>
          <Title level={4} style={{ marginTop: "24px" }}>
            Partner Şirketler
          </Title>
          <Space>
            {[1, 2, 3, 4].map((_, index) => (
              <img
                key={index}
                src={personelIcon}
                alt="Partners"
                style={{ marginRight: "8px", width: 50 }}
              />
            ))}
          </Space>
        </Col>
      </Row>

      <Row
        justify="center"
        style={{
          marginTop: "48px",
          borderTop: "1px solid #333",
          paddingTop: "24px",
        }}>
        <Col>
          <Text>© Developed by Anemo Technology. All Rights Reserved.</Text>
        </Col>
      </Row>
    </Footer>
  );
}
